import React from 'react';
import './TextButton.css'; // 导入样式文件

interface TextButtonProps {
    text: string; // 按钮文本
    color:string;
    onClick: (event: React.MouseEvent<HTMLSpanElement>) => void; // 点击事件处理函数
}

const TextButton: React.FC<TextButtonProps> = ({ text, color, onClick }) => {
    const handleClick = (event: React.MouseEvent<HTMLSpanElement>) => {
        event.stopPropagation(); // 阻止事件传播
        onClick(event); // 调用传入的 onClick 事件处理函数
    };

    return (
        <span className="text-button" style={{color:color, textDecoration:'none', paddingInline:'10px'}} onClick={handleClick}>
            {text}
        </span>
    );
};

export default TextButton;